module.exports = __webpack_public_path__ + "img/25x25_gri.41ab51cc.gif";